
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 16,
  width: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.284 9.437a1.208 1.208 0 0 0 .026 1.711l6.01 5.844-5.844 6.023a1.208 1.208 0 0 0 .026 1.71c.48.467 1.244.455 1.71-.025l5.845-6.023 6.022 5.845c.48.466 1.245.454 1.71-.026a1.208 1.208 0 0 0-.025-1.71l-6.022-5.845 5.844-6.022a1.208 1.208 0 0 0-.026-1.711 1.208 1.208 0 0 0-1.71.025l-5.845 6.023-6.022-5.844a1.216 1.216 0 0 0-1.699.025z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"16\" width=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\">     <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.284 9.437a1.208 1.208 0 0 0 .026 1.711l6.01 5.844-5.844 6.023a1.208 1.208 0 0 0 .026 1.71c.48.467 1.244.455 1.71-.025l5.845-6.023 6.022 5.845c.48.466 1.245.454 1.71-.026a1.208 1.208 0 0 0-.025-1.71l-6.022-5.845 5.844-6.022a1.208 1.208 0 0 0-.026-1.711 1.208 1.208 0 0 0-1.71.025l-5.845 6.023-6.022-5.844a1.216 1.216 0 0 0-1.699.025z\" fill=\"var(--theme-primary, #810ea9)\"></path>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/close.2b6c88f8aa3dc4b3ed122152cb7f69e6.svg"),
        {
          React: SvgClose,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      